import React, {useState} from "react";
import Select from "react-select"
import { useMutation } from "@apollo/client";
import UpdateProblem from "../../mutations/UpdateProblem";
import GetSurveysForProblems from "../../queries/GetSurveysForProblems";
// reactstrap components
import { FormGroup, Input, Button, FormText } from "reactstrap";

const ErrorResponseRow = ({dIndex, pIndex, problem}) => {
  const [response, setResponse] = useState(() => {
    if (problem.response && problem.response !== "" && problem.response !== undefined) {
      return problem.response;
    } else {
      return "";
    }
  });
  const [selectedStatus, setSelectedStatus] = useState(() => {
    // Check if problem.status exists and is not null or undefined
    if (problem.status !== undefined && problem.status !== null) {
      // Capitalize the status word
      const capitalizedStatus = problem.status.charAt(0).toUpperCase() + problem.status.slice(1);
      // Return the capitalized status word as the label
      return { value: problem.status, label: capitalizedStatus };
    } else {
      // Return default value if problem.status is not provided, null, or undefined
      return { value: null, label: "None" };
    }
  });
  const [errors, setErrors] = useState([])

  const [updateProblem] = useMutation(UpdateProblem)

  const handleMutation = (variables) => {
    return updateProblem({
      variables,
      refetchQueries: [
        {
          query: GetSurveysForProblems
        }
      ]
    })
  }

  function updateStatus() {
    let newErrors = [];

    if(selectedStatus.value === null) newErrors.push({key: "status", text: "Please select a status."})
    if(response === "") newErrors.push({key: "response", text: "Please type a response."})

    setErrors(newErrors)

    if(newErrors.length === 0) {
      const variables = {
        problemId: problem.id,
        status: selectedStatus.value,
        response: response
      }

      console.log("trying to send: ", variables);

      handleMutation(variables)
    }
  }

  // Custom styles
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: '30px',
      height: '30px',
      fontSize: '12px',
      width: '110px'
    }),
    valueContainer: (base) => ({
      ...base,
      height: '30px',
      padding: '0 6px'
    }),
    input: (base) => ({
      ...base,
      margin: '0px',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: '30px',
    }),
  };

  // Custom components
  const DropdownIndicator = () => null; // Removes the dropdown indicator

  return (
    <tr key={`problem_${dIndex}_${pIndex}_status_response`}>
      <td>
        <Button color="primary" onClick={() => updateStatus()}>Update</Button>
      </td>
      <td>
        <Select
          value={selectedStatus}
          onChange={(selectedStatus) => {
            setSelectedStatus(selectedStatus);
          }}
          options={[
            {
              value: null,
              label: "None",
            },
            {
              value: "addressed",
              label: "Addressed",
            },
            {
              value: "nonactionable",
              label: "Nonactionable",
            }
          ]}
          className="form-control-alternative"
          id="input-status"
          styles={customStyles}
          components={{ DropdownIndicator }}
        />
        <FormText className='text-red'>
          {errors.some((error) => error.key === "status") ? (
            errors.find((error) => error.key === "status").text
          ) : (
            <></>
          )}
        </FormText>
      </td>
      <td colSpan="2">
        <div style={{ whiteSpace: 'nowrap' }}>
          <FormGroup className='mt-3'>
            <Input
              type="textarea"
              className='form-control mb-2'
              id={problem.id}
              name={problem.id}
              placeholder="Please add response"
              value={response != null ? response : ""}
              onChange={(e) => setResponse(e.target.value)}
              rows={3}
            />
            <FormText className='text-red'>
              {errors.some((error) => error.key === "response") ? (
                errors.find((error) => error.key === "response").text
              ) : (
                <></>
              )}
            </FormText>
          </FormGroup>
        </div>
      </td>
    </tr>
  )
}

export default ErrorResponseRow